import ApiService from "@/utils/api.service";

export default {
    deleteEdit(context, edit) {
        return new Promise((resolve, reject) => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.delete("job/" + edit.job_id + "/edit/" + edit.id)
                .then((data) => {
                    resolve(data);
                })
                .catch((data) => {
                    reject(data)
                }).finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                })
        })
    },
    getEditsList(context, jobId) {
        return new Promise((resolve, reject) => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.get("job/" + jobId + "/list-edits")
                .then(({ data }) => {
                    context.commit("setEditsList", data);
                    resolve(data);
                })
                .catch((data) => {
                    reject(data)
                }).finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                })
        })
    },
    addEdit(context, model) {
        return new Promise((resolve, reject) => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.post("job/" + model.jobId + "/edit", model)
                .then((data) => {
                    resolve(data);
                })
                .catch((data) => {
                    reject(data)
                }).finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                })
        })
    },
    addOption(context, model) {
        return new Promise((resolve, reject) => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.post("job/" + model.jobId + "/edit/" + model.editId + "/option", model)
                .then((data) => {
                    resolve(data);
                })
                .catch((data) => {
                    reject(data)
                }).finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                })
        })
    },

    sent(context, jobId) {
        return new Promise((resolve, reject) => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.put("job/" + jobId + "/sent")
                .then((data) => {
                    resolve(data);
                })
                .catch((data) => {
                    reject(data)
                }).finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                })
        })
    }


}